import { AfterViewInit, Component, ViewChild, ElementRef, Inject, NgZone, ChangeDetectorRef } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule, DOCUMENT, Location } from '@angular/common';
import { SignupuserService } from '../../services/signupuser.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { DialogModule } from 'primeng/dialog';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.css',
})
export class SignupComponent implements AfterViewInit {
  constructor(private title: Title, private location: Location, private ngZone: NgZone, private changeDetector: ChangeDetectorRef, @Inject(DOCUMENT) document: Document, private router: Router, private meta: Meta, private signupService: SignupuserService, private spinner: NgxSpinnerService, private authService: AuthService) {
  }
  @ViewChild('Email') emailVer!: ElementRef;
  @ViewChild('passI') passI!: ElementRef;
  @ViewChild('confirmI') confirmI!: ElementRef;
  @ViewChild('RAFcode') RAFcode!: ElementRef;
  @ViewChild('signUp_intro') signUp_intro!: ElementRef;
  observer:any;
  firstName: any;
  lastName: any;
  email: any;
  selectedPhoneNum: any;
  occupation: any;
  mailaddress: any;
  selectedcity: any;
  selectedState: any;
  selectedZip: any;
  referaFriend: any ='';
  selectedPassword: any;
  confirmPassword: any;
  emailNotify: boolean = false;
  smsNotify: boolean = false;
  showMobileErr: boolean = false;
  showMobileMsg: any;
  showEmailErr: boolean = false;
  showEmailMsg: any;
  dialogBox1: boolean = false;
  headerContentaddUser1: any = 'Alert';
  dialogMessage: any = 'Enter Mandatory Fields';
  showErrPass: boolean = false;
  showErrPassMsg: any ='';
  showErrConfirmPass: boolean = false;
  showErrPassMsgConf: any;
  successBox: boolean = false;
  signUpFlag: boolean = true;
  errFlag: boolean = true;
  errorMsg: any = '';
  errFlag1: boolean = true;
  errorMsg1: any;
  errMail: boolean = false;
  errMailMsg: any;
  errCity: boolean = false;
  errCityMsg: any;
  validErrPoup: boolean = false;
  hidePasswordField: boolean = false; reQuid: boolean = true; oktaId: any;
  showReffer:boolean =  false;
  referMsgDisplay:any ='';
  errStorenReg:boolean = false;
  errConfirmFlag:boolean = false;
 referrerGUID:any = null;
 referrerFirst:any = null;
 referrerLast:any = null;
  ngAfterViewInit(): void {
    localStorage.removeItem('issignupsuccess');
    this.showReffer = false;
    this.referMsgDisplay ='';
    // this.router.navigate([], { fragment: "signUp_intro" });
    this.signUp_intro.nativeElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest"
    });
    if (this.isScriptLoaded('sign-up.js')) {
    
    } else {
      
      this.signupService.loadScript('sign-up.js').then(() => {
        
      }).catch(error => {
        console.error('script errr', error);
      })
    }
  }
  isScriptLoaded(filePath: any): boolean {
    return document.querySelector(`script[src="${filePath}"]`) !== null;
  }
  ngOnInit() {
    this.authService.checkAuthAndRedirectHome();
    this.title.setTitle("Sign Up | Storen Satisfaction Program");
    this.meta.updateTag({ name: 'description', content: 'Sign up for the Storen Satisfaction Program' });
    localStorage.removeItem('issignupsuccess');

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event.navigationTrigger === 'popstate') {
          window.location.reload();
        }
      }
    })


  }


  validateEmailExist(event: any) {
    this.spinner.show();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid = emailRegex.test(this.email);
    if (valid === true) {
      this.showEmailErr = false;
      this.showEmailMsg = "";
      this.signupService.validateEmailExist(this.email).subscribe(res => {
        if (res.length > 0) {
          let userID = res[0]['UserId'];
          this.oktaId = res[0]['Profile']['OktaId'];

          this.spinner.hide();
          if (userID !== 0 && this.oktaId !== null) { 
            this.showEmailErr = true;
            this.hidePasswordField = false;
            this.showEmailMsg = 'An account using this email address already exists. Please use a different email address or login to the existing account.';
            this.emailVer.nativeElement.parentElement.classList.add("validation-error");
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            this.reQuid = true;
            this.spinner.hide();
          } else if (userID === 0 && this.oktaId !== null) {  // Autofill Values and Hide password field eg:infy_support@yopmail.com
            this.showEmailErr = false;
            this.showEmailMsg = "";
            this.hidePasswordField = true;
            this.firstName = res[0]['Profile']['FirstName'] !== null ? res[0]['Profile']['FirstName'] : res[0]['Profile']['FirstName'];
            this.lastName = res[0]['Profile']['LastName'] !== null ? res[0]['Profile']['LastName'] : res[0]['Profile']['LastName'];
            // this.selectedZip = res[0]['Profile']['ZipCode'] !== null ? res[0]['Profile']['ZipCode'] : res[0]['Profile']['ZipCode'];
            // this.selectedPhoneNum = res[0]['Profile']['PhoneNumber'] !== null ? res[0]['Profile']['PhoneNumber'] : res[0]['Profile']['PhoneNumber'];
            // this.selectedcity = res[0]['Profile']['City'] !== null ? res[0]['Profile']['City'] : res[0]['Profile']['City'];
            // this.mailaddress = res[0]['Profile']['Address'] !== null ? res[0]['Profile']['Address'] : res[0]['Profile']['Address'];
            // this.selectedState = res[0]['Profile']['State'] !== null ? res[0]['Profile']['State'] : res[0]['Profile']['State'];
            // this.occupation = res[0]['Profile']['Role'] !== null ? res[0]['Profile']['Role'] : res[0]['Profile']['Role'];
            // this.emailNotify = false;
            // this.smsNotify = false;
            // this.passI.nativeElement.value  = 'test@123';
            // this.confirmI.nativeElement.value = 'test@123';
            this.reQuid = false;
            this.emailVer.nativeElement.parentElement.classList.remove("validation-error");
            this.spinner.hide();

          }else{
            this.reQuid = true;
            this.showEmailErr = false;
            this.showEmailMsg = "";
            this.hidePasswordField = false;
            this.emailVer.nativeElement.parentElement.classList.remove("validation-error");
            this.spinner.hide();
          }
        } else {
          this.spinner.hide();
          this.reQuid = true;
          this.showEmailErr = false;
          this.showEmailMsg = "";
          this.hidePasswordField = false;
          this.emailVer.nativeElement.parentElement.classList.remove("validation-error");
        }
      });
    } else {
      this.spinner.hide();
      this.showEmailErr = true;
      this.hidePasswordField = false;
      this.showEmailMsg = 'Please enter valid email.';
      this.emailVer.nativeElement.parentElement.classList.add("validation-error");
    }

  }

  ValidRAFcode(evt:any){
    this.spinner.show();
    let codeToValdate = this.referaFriend;
        if (this.referaFriend === '') {
          this.showReffer = false;
          this.referMsgDisplay ='';
          this.RAFcode.nativeElement.classList.remove("validation-error");
          this.spinner.hide();
        } 
        else if(this.referaFriend !== ''){
        const data = new URLSearchParams();
          data.append("codeToValdate", codeToValdate.toLowerCase()); // Transform to lowercase since that's how they're actually stored in the data extension
      fetch("https://marketing.syngenta-us.com/validate-2024-ssp-raf-code", {
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then(response => response.text())
      .then(dataTest => {
        if (dataTest.trim() != "No rows found") {
          [this.referrerGUID, this.referrerFirst, this.referrerLast] = dataTest.trim().split(';').map(value => value.trim());
          console.debug("[" + Date.now() + "] SSP Staging Alert: Matching referrer found: " + this.referrerGUID + " (" + this.referrerFirst + " " + this.referrerLast + ")");
          // document.getElementById("rafCode")?.value = codeToValdate.toUpperCase(); // Transform to uppercase since it looks nicer for the end user
         // document.getElementById("rafCode")?.disabled = true;
        // clearValidationError(document.getElementById("rafCode"));
          this.RAFcode.nativeElement.value = codeToValdate.toUpperCase();
          this.RAFcode.nativeElement.disabled = true;
          this.showReffer = false;
          this.referMsgDisplay='';
          console.debug("[" + Date.now() + "] SSP Staging Alert: RAF code passed Marketing Cloud validation and was populated into the form.");
          this.RAFcode.nativeElement.parentElement.classList.remove("validation-error");
          document.getElementById("rafCode")?.classList.add("valid-raf-code");
          this.spinner.hide();
     
        //  console.log(this.referrerGUID, this.referrerFirst, this.referrerLast);
          // return { referrerGUID, referrerFirst, referrerLast };
        } else {
          // markValidationError(document.getElementById("rafCode"));
          this.showReffer = true;
          this.referMsgDisplay ="The Referral code you provided isn't valid. Please enter a correct code to continue.";
          this.RAFcode.nativeElement.parentElement.classList.add("validation-error");
          document.getElementById("rafCode")?.classList.remove("valid-raf-code");
          console.error("[" + Date.now() + "] SSP Staging Alert: No matching referrer found.");
          this.spinner.hide();
        }
      }).catch(error =>{
        console.error("[" + Date.now() + "] SSP Staging Alert: RAF code did not make it up to Marketing Cloud for verification. Contact G&S.")
      })
     
        }
  }
  validPassword(evt:any){
    if(this.selectedPassword ===''){
       this.showErrPass = false;
       this.showErrPassMsg = '';
    }
    if (this.selectedPassword?.trim() !== this.confirmPassword?.trim()) {
      this.errConfirmFlag = true;
      this.confirmI.nativeElement.parentElement.classList.add("validation-error");
    } else {
      this.errConfirmFlag = false;
      this.confirmI.nativeElement.parentElement.classList.remove("validation-error");
    }
  }
  validConfirm(){
    console.log(this.selectedPassword, this.confirmPassword);
    if (this.selectedPassword?.trim() !== this.confirmPassword?.trim()) {
      this.errConfirmFlag = true;
      this.confirmI.nativeElement.parentElement.classList.add("validation-error");
    } else {
      this.errConfirmFlag = false;
      this.confirmI.nativeElement.parentElement.classList.remove("validation-error");
    }
  }
  onlyNumber(evt: any) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  signUpClick(signUpform: any) {
    this.spinner.show();
    let confirmPass: any;
    if (this.confirmPassword === 'undefined' || this.confirmPassword === undefined && this.hidePasswordField === true) {
      confirmPass = "";
    } else {
      confirmPass = this.confirmPassword;
    }
    let OktaId: any;
    if (this.oktaId !== null && this.oktaId !== 'undefined' && this.oktaId !== undefined) {
      OktaId = this.oktaId;
    } else {
      OktaId = "";
    }

    if (this.referaFriend !== undefined && this.referaFriend !== "" && this.referaFriend !== null && this.referaFriend !== 'undefined') {
     
      if(this.RAFcode.nativeElement.parentElement.className.indexOf('validation-error') >-1){
        this.showReffer = true;
        this.referMsgDisplay = "The Referral code you provided isn't valid. Please enter a correct code to continue.";
        // this.spinner.hide();
        this.RAFcode.nativeElement.classList.add("validation-error");
      } else {
        this.showReffer = false;
        this.referMsgDisplay = '';
        this.RAFcode.nativeElement.classList.remove("validation-error");
       // this.spinner.hide();
      }
    }

    if (signUpform.valid === true && !this.showEmailErr && this.emailNotify && this.smsNotify && !this.showReffer && !this.errConfirmFlag) {
      this.marketingCloud_sendRegistration();
      let obj = {
        "Email": this.email,
        "Password": confirmPass,
        "FirstName": this.firstName,
        "LastName": this.lastName,
        "CompanyName": "",
        "AddressLine1": this.mailaddress,
        "City": this.selectedcity,
        "State": this.selectedState,
        "Zipcode": this.selectedZip,
        "PhoneNumber": this.selectedPhoneNum,
        "ProgramName": "SSP",
        "Role": this.occupation,
        "OktaId": OktaId,
        "IsActive": 1,
        "IsNewUser": true,
        "User_Geo_Lat": 0,
        "User_Geo_Lon": 0,
        "Email_Notification": this.emailNotify === true ? 1 : 0,
        "SMS_Notification": this.smsNotify === true ? 1 : 0,
        "Emailchanged": false,
        "OldEmailId": "",
        "Temppwd": "",
        "Refer_a_Friend_code": this.referaFriend !== undefined ? this.referaFriend : ''
      };

      this.signupService.storenregister(obj).subscribe(res => {
        if (res.Status === 'Success') {
          this.spinner.hide();
          localStorage.setItem('issignupsuccess', 'true');
          this.router.navigateByUrl('/sign-up/success');
        } else if(res.Reason=== "Api validation failed: password"){
          localStorage.removeItem('issignupsuccess');
          this.showErrPass  = true;
          this.showErrPassMsg = 'The password you entered is too common and may be easily guessed. Please choose a stronger, less predictable password.';
          this.passI.nativeElement.parentElement.classList.add("validation-error");
          this.spinner.hide();
        } else {
          localStorage.removeItem('issignupsuccess');
          this.errStorenReg  = true;
          this.showErrPass  = false;
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          this.spinner.hide();
        }
      }, (error => {
        this.spinner.hide();
        localStorage.removeItem('issignupsuccess');
        this.router.navigateByUrl('error');
      }));
    } else {
      this.spinner.hide();
      localStorage.removeItem('issignupsuccess');
      console.log("jjhj");
    }
  } 

  marketingCloud_sendRegistration(){
    //const data = {
      //FirstName: this.firstName,
      //LastName: this.lastName,
      //Email: this.email,
      //Phone: this.selectedPhoneNum,
      //Occupation: this.occupation,
      //State: this.selectedState,
      //EmailConsent: this.emailNotify,
      //SMSConsent: this.smsNotify,
      //ReferrerGUID: this.referrerGUID,
      //ReferrerFirstName: this.referrerFirst,
      //ReferrerLastName: this.referrerLast,
      //CurrentPageUrl: window.location.href,
      //Timestamp: Date().toString(),
      //TimestampUnix: Date.now()
    //}

    const data = new URLSearchParams({
      FirstName: this.firstName,
      LastName: this.lastName,
      Email: this.email,
      Phone: this.selectedPhoneNum,
      Occupation: this.occupation,
      State: this.selectedState,
      EmailConsent: this.emailNotify.toString(),
      SMSConsent: this.smsNotify.toString(),
      ReferrerGUID: this.referrerGUID,
      ReferrerFirstName: this.referrerFirst,
      ReferrerLastName: this.referrerLast,
      CurrentPageUrl: window.location.href.toString(),
      Timestamp: Date().toString(),
      TimestampUnix: Date.now().toString()
    }).toString();

//  console.log(data);
    //let finalObj = JSON.stringify(data);
    //console.log("testdata",JSON.stringify(data));
    fetch("https://marketing.syngenta-us.com/storen-satisfaction-program-acp-registration-mobileconnect", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: data
    })
    .then(response => response.text())
    .then(data => {
      if (data.includes("Duplicate")) {
        console.error("[" + Date.now() + "] SSP Staging Alert: A record with this email address already exists in Marketing Cloud. Rejecting sign up as duplicate.");
      } else if (data.includes("success")) {
        console.debug("[" + Date.now() + "] SSP Staging Alert: Sign up information successfully sent to Marketing Cloud");
      }
    })
    .catch(error => {
      // alert("Something went wrong. Please try again later.");
      console.error("[" + Date.now() + "] SSP Staging Alert: Registration data did not make it up to Marketing Cloud. Contact G&S.")
    });
  }
}
